import { PlayListDisplay } from "@/components/playlist/PlayListDisplay";
import { useTerminal } from "@/pages/data/terminal/terminal-utils";
import { usePage } from "@/components/page/PageContext";
import { useEffect } from "react";
import { getPlays } from "@/queries/plays";
import { useReportContext } from "@/stores/ReportContext";
import { useConcourse } from "@/pages/data/concourse/concourse-utils";

export function TerminalPlaylistPage() {
  const terminal = useTerminal();
  const { setTitles } = usePage();
  useEffect(() => {
    setTitles(["Pain Points"]);
  }, []);
  const { reportId } = useReportContext();

  const { data, isSuccess } = getPlays(reportId, {
    terminal_name: terminal.name,
  });

  return <div>{isSuccess && <PlayListDisplay plays={data.plays} />}</div>;
}

export function ConcoursePlaylistPage() {
  const concourse = useConcourse();
  const { setTitles } = usePage();
  useEffect(() => {
    setTitles(["Pain Points"]);
  }, []);
  const { reportId } = useReportContext();

  const { data, isSuccess } = getPlays(reportId, {
    concourse_name: concourse.name,
  });

  return <div>{isSuccess && <PlayListDisplay plays={data.plays} />}</div>;
}
